module.exports = __webpack_public_path__ + "img/weheartit.7e2e6e3b.png";